/*
 * Runtime config for the marketing landing page.
 *
 * Brand values (name, accent colour) come from the tenant theme at render
 * time (see useLandingBrand). URLs that point outside React Router — the
 * Discord invite and the standalone terminal/app origin — are read from
 * REACT_APP_* env so they are never hardcoded into JSX. CRA inlines these at
 * build time; the fallbacks keep the default FlockTrade deployment working
 * with no env set.
 */

// Discord community invite. Override per deployment with REACT_APP_DISCORD_INVITE_URL.
export const DISCORD_INVITE_URL =
  process.env.REACT_APP_DISCORD_INVITE_URL || 'https://discord.com/invite/sQjPufbufK';

// Where "open the terminal / app" links point. Same-origin /terminal by
// default; a dedicated app subdomain can override via REACT_APP_APP_URL.
export const APP_URL = process.env.REACT_APP_APP_URL || '/terminal';

// FlockTrade brand defaults — used when no tenant theme is active.
export const BRAND_DEFAULTS = {
  name: 'FlockTrade',
  wordmark: 'FLOCKTRADE',
};
